module.exports = __webpack_public_path__ + "img/goods.9cd93bf5.svg";